import { Link, styled } from "@mui/material";

export const StyledLink = styled(Link)`
	text-decoration: none;
	font-size: inherit;
`;
